export function land_sprites(k){

const taskBar = add([
    k.sprite("barraTareas"),
    k.pos(0,938),
])

}